import { FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const StreakCalendarGridHeader = () => {
  const theme = useStatsTheme((s) => s.theme)

  return (
    <div
      className={css`
        margin-bottom: 8px;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 6px;
      `}
    >
      {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, i) => (
        <FlexBox
          key={i}
          className={css`
            width: 100%;
          `}
          justifyContent="center"
        >
          <Text
            type="label"
            sizing="L"
            weight="500"
            align="center"
            color={theme.colors.section.textSecondary}
          >
            {day}
          </Text>
        </FlexBox>
      ))}
    </div>
  )
}
